export class LocationInformation {
    public constructor(init?: Partial<LocationInformation>) {
        Object.assign(this, init);
             this.technicianTeam = this.technicianTeam ?? '';
        this.deliveryLocation = this.deliveryLocation ?? '';
    }

    technicianTeam: string='';
    deliveryLocation: string='';
}
